<template>
  <v-bottom-sheet 
    v-if="isMobile"
    v-model="drawer">
    <v-list 
      v-touch="{
        down: () => swipe()
      }"
      
      style="overflow: scroll; height: 90vh; border-top-left-radius: 24px; border-top-right-radius: 24px;"
      class="  ma-0 pa-0">
      <!-- <div style="height: 20px; background-color: rgba(255,255,255,0); opacity: 1;">
        <hr class="menuline">
      </div> -->

      <!-- <v-layout 
        class="py-3 "
        align-center 
        justify-center>
        <hr
          class="menuline"> -->

      <!-- <div 
          style="background-color: red; border: 2px solid lightgrey; border-radius: 10px; width: 72px" /> -->
      <!-- </v-layout> -->

      <app-timeline-filter-menu-overview></app-timeline-filter-menu-overview>
    </v-list>
  </v-bottom-sheet>


  <v-navigation-drawer
    v-else
    v-model="drawer"
    right
    fixed
    floating
    clipped
    temporary
    width="400"
    style="border-top-left-radius: 24px; border-bottom-left-radius: 24px; ">
    <app-timeline-filter-menu-overview></app-timeline-filter-menu-overview>
  </v-navigation-drawer>
</template>
    

<script>
import TimelineFilterMenuOverview       from '@/components/global_comps/Filter/TimelineFilter_Menu_Overview'

import { mapState, mapMutations } from 'vuex'


export default {
  components: {
    // eslint-disable-next-line
    AppTimelineFilterMenuOverview: TimelineFilterMenuOverview
  },
  data() {
    return {
    }
  },

  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
      filter_timelinedrawer: state => state.timeline.timelineFilter.filter_timelinedrawer
    }),

    

    drawer: {
      get() {
        return this.filter_timelinedrawer
      },
      set(value) {
        if (this.filter_timelinedrawer !== value) {
          this.clicktimelinedrawer(value)
        }
      }
    }
  },
  methods: {
    ...mapMutations([
      'clicktimelinedrawer',
    ]),
   
    swipe() {
      this.drawer = false
    },
    
  }
}
</script>


<style scoped>
.menuline {
  border: 2px solid lightgrey;
  margin: auto;
  border-radius: 10px; 
  width: 72px;
}
</style>
